import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute } from "@angular/router";
import { TechnicalLetterService } from "../../services/technical-letters/technical-letter.service";
import { LetterEquipmentHistory } from "../../interfaces/technical-letters/letter-equipment-history.models";

@Component({
    selector: "app-history-log",
    templateUrl: "./history-log.component.html",
    standalone: false
})
export class HistoryLogComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ["when", "who", "disposition", "comments"];
  dataSource = new MatTableDataSource<any>([]);
  loading = false;
  error: string | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private technicalLetterService: TechnicalLetterService
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get("id"));
    if (id) {
      this.technicalLetterService.getLetterEquipmentHistory(id).subscribe({
        next: (data: LetterEquipmentHistory[]) => {
          this.dataSource.data = data.map((item) => ({
            when: item.rowUpdatedDate,
            who: item.rowUpdatedBy,
            disposition: item.letterDispositionLkp?.lookupValue,
            comments: item.comments,
          }));
          this.error = null;
        },
      });
    } else {
      this.error = "No equipment history ID provided.";
    }
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
}
